import RequestBlock from './RequestBlock.jsx';
import LinkedProposalBlock from './LinkedProposalBlock.jsx';
import { ClaimsList, DetailSections } from '../shared/index.js';

/**
 * Gov Review detail body: who requested the review, the linked proposal, and
 * the items to decide. Decision controls live in the pinned footer.
 */
function GovReviewBody({ event }) {
  const detail = event.detail ?? {};
  const sections = [
    <RequestBlock key="request" detail={detail} />,
    detail.linkedProposal ? (
      <LinkedProposalBlock key="linked" linkedProposal={detail.linkedProposal} />
    ) : null,
    <ClaimsList key="claims" event={event} titleKey="govReview.itemsToReview" />,
  ].filter(Boolean);

  return <DetailSections sections={sections} />;
}

export default GovReviewBody;
